<template>
	<div class="game-intro game-intro-new game-intro__mb" :style="{ margin: game.imageArrangement === 'left' ? '' : '10% -0% 10% -10%'}">
        
        <mq-layout :mq="['mob', 'ptab']" class="game-detail__banner width-100" v-bind:style="{ backgroundImage: `url('${overviewImage}')` }">
			<btn class="btn--style--fill--font center-button" @click="watchVideo()" v-if="overviewVideo">
				<span class="fonticon fonticon--play"></span>
				<span>Watch Video</span>
			</btn>
        </mq-layout>  
		<div :style="{ float: game.imageArrangement === 'left' ? 'right' : 'left' }" class="game-intro__content game-intro__content__mb">
			<div class="game-intro__left-content">
				<h2 class="h2 game-intro__name">{{game.featureTitle}}</h2>
				<div v-if="game.blurb" v-html="formatDescription(game.blurb)" class="game-intro__description"></div>
			</div>
		</div>
        <div :style="{ float: game.imageArrangement === 'left' ? 'left' : 'right' }" class="game-intro__image game-intro__image__mb">
            <mq-layout :mq="['ltab', 'desk']" class="grid__item" v-bind:style="{ backgroundImage: `url('${overviewImage}')`, height: '150%', width: '120%', backgroundSize: 'contain', backgroundRepeat: 'no-repeat', position: 'relative' }">
				<btn class="btn--style--fill--font center-button" @click="watchVideo()" v-if="overviewVideo">
					<span class="fonticon fonticon--play"></span>
					<span>Watch Video</span>
				</btn>
            </mq-layout>
        </div>
	</div>
</template>

<script>
import Btn from '../atoms/Btn'
export default {
	name: 'EnhancedFeaturesIntro',
	components: {
		Btn
	},
	props: {
		game: Object,
	},
	methods: {
		formatDescription(str) {
			// Adapted from https://stackoverflow.com/a/7467865
			return str.replace(/([^>\r\n]?)(\r\n|\n\r|\r|\n)/g, '$1' + '<br>' + '$2');
		},
		watchVideo: function()
		{
			var self = this;

			self.$root.$data.gameVideoId = self.overviewVideo;

			self.trackEvent([
				'video-played',
				self.overviewVideo,
				self.$root.$data.user ? self.$root.$data.user.trackName : null,
				0,
				false
			]);

			self.trackEvent([
				'game-video-played',
				self.game.gameTitle,
				self.$root.$data.user ? self.$root.$data.user.trackName : null,
				0,
				false
			]);
		},
	},
    computed: {
        overviewImage: function()
		{
			var self = this;
			var overviewImage = '';
            
			if(self.game.assets.heroFeaturedImage && self.game.assets.heroFeaturedImage.length > 0)
			{
				overviewImage = self.game.assets.heroFeaturedImage[0].link;
			}

			return overviewImage;
		},
		overviewVideo: function()
		{
			var self = this;
			var overviewVideo = '';
			
			if(self.game.videoId) {
				overviewVideo = self.game.videoId;
			}else if(self.game.assets.heroLinkedVideo && self.game.assets.heroLinkedVideo.length > 0)
			{
				overviewVideo = self.game.assets.heroLinkedVideo[0].link;
			}

			return overviewVideo;
		}
    }
}
</script>

<style lang="scss">
	@import "src/scss/toolkit";

	$c: ".game-intro";
	#{$c}
	{
		&__btns
		{
			margin-bottom: rem(16);
		}

		&__btn
		{
			padding-left: 12px;
			padding-right: 18px;
			font-size: 12px !important;
		}

		&__icon
		{
			font-size: rem(16);
			color: palette('yellow');
		}

		&__name
		{
			margin-bottom: rem(24);
		}

		&__meta
		{
			margin-bottom: rem(32);
		}

		&__separator
		{
			display: block;
			line-height: 0;
			width: 1px;
			height: rem(24);
			background-color: palette(divider);
		}

		&__date
		{
			@include extend(h5);
			margin-bottom: rem(8);
		}

		&__channel
		{
			font-size: rem(32);
		}

		&__description
		{
			color: palette('grey');
		}

        &__content {
            display: flex;
            justify-content: center;
            align-items: center;
            flex-direction: column;
            height: 100%;
            text-align: center;
            width: 50%;
            float: left;
        }

        &__image
		{
            position: relative;
            top: 50%;
            float: right;
            display: flex;
            justify-content: center;
            align-items: center;
            flex-direction: column;
            height: 250px;
            width: 500%;
            
            @include media(not-phab) {
                max-width: 536px;
            }
		}

		&__actions
		{
			margin-top: rem(32);
		}
	}

</style>
<style scoped>
	.game-intro-new {
        height: 500%;
        width: 215%;
		padding: 30px;
	}
	.center-button {
		position: absolute;
		top: 50%;
		left: 50%;
		transform: translate(-50%, -50%);
	}
	.game-intro__content {
		display: flex;
		justify-content: space-between;
		align-items: center;
		padding: 50px;
	}
	.game-intro__left-content {
		text-align: left;
		}
		
		
</style>



// WEBPACK FOOTER //
// src/components/molecules/EnhancedFeaturesIntro.vue